import { render, staticRenderFns } from "./MediaConfig.vue?vue&type=template&id=37ecea32&scoped=true"
import script from "./MediaConfig.vue?vue&type=script&lang=js"
export * from "./MediaConfig.vue?vue&type=script&lang=js"
import style0 from "./MediaConfig.vue?vue&type=style&index=0&id=37ecea32&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ecea32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37ecea32')) {
      api.createRecord('37ecea32', component.options)
    } else {
      api.reload('37ecea32', component.options)
    }
    module.hot.accept("./MediaConfig.vue?vue&type=template&id=37ecea32&scoped=true", function () {
      api.rerender('37ecea32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/MediaConfig.vue"
export default component.exports